import React, { useState, useRef, useEffect, useCallback } from "react";
import { useSpring, animated } from "react-spring";
import {
  Background,
  ModalContent,
  CloseModalButton,
  Form,
  FormContent,
  Button,
  Input,
  Select,
  Label,
} from "../../ModalEditStyle";
import api from "../../../../services/api";
import Swal from "sweetalert2";
import Auth from "../../../../services/auth";

export default function ModalRegister({ showModal, setShowModal, data }) {
  const modalRef = useRef();
  const [idCoord] = useState(Auth.id());
  const [unidades, setUnidades] = useState([]);
  const [unidade, setUnidade] = useState("");
  const [cursos, setCursos] = useState([]);
  const [curso, setCurso] = useState("");
  const [centros_custo, setCentros_custo] = useState([]);
  const [centro_custo, setCentro_custo] = useState("");
  const [turmas, setTurmas] = useState([]);
  const [turma, setTurma] = useState("");
  const [data_inicio, setData_inicio] = useState("");
  const [data_fim, setData_fim] = useState("");
  const [id, setId] = useState("");
  const [idUnidade, setIdUnidade] = useState(0);
  const [id_centro_custo, setId_centro_custo] = useState(0);
  const [idCurso, setIdCurso] = useState(0);
  const [idTurma, setIdTurma] = useState(0);
  const animation = useSpring({
    config: {
      duration: 150,
    },
    opacity: showModal ? 1 : 0,
    transform: showModal ? `translateY(0%)` : `translateY(-100%)`,
  });
  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 1000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });

  const keyPress = useCallback(
    (e) => {
      if (e.key === "Escape" && showModal) setShowModal(!showModal);
    },
    [setShowModal, showModal]
  );

  useEffect(() => {
    if (!showModal) return;
    api
      .get(`/coord/courses`)
      .then((response) => {
        setCursos(response.data.cursos);
      })
      .catch((error) => {
        Swal.fire({
          title: "Atenção!",
          text: "Não foi possível consultar os dados!",
          icon: "error",
        });
      });
    api
      .get(`/coord/costcenter`)
      .then((response) => {
        setCentros_custo(response.data.centros_custo);
      })
      .catch((error) => {
        Swal.fire({
          title: "Atenção!",
          text: "Não foi possível consultar os dados!",
          icon: "error",
        });
      });
    api
      .get(`/coord/units?idCoord=${idCoord}`)
      .then((response) => {
        setUnidades(response.data.unidades);
      })
      .catch((error) => {
        Swal.fire({
          title: "Atenção!",
          text: "Não foi possível consultar os dados!",
          icon: "error",
        });
      });
    api
      .get(`/coord/classes?idCoord=${idCoord}`)
      .then((response) => {
        setTurmas(response.data.turmas);
      })
      .catch((error) => {
        Swal.fire({
          title: "Atenção!",
          text: "Não foi possível consultar os dados!",
          icon: "error",
        });
      });
  }, [idCoord, showModal]);

  useEffect(() => {
    document.addEventListener("keydown", keyPress);
    return () => document.removeEventListener("keydown", keyPress);
  }, [keyPress]);

  useEffect(() => {
    if (!showModal) return;
    if (data) {
      setIdUnidade(data.id_unidade);
      setUnidade(data.unidade);
      setCurso(data.curso);
      setIdCurso(data.id_curso);
      setCentro_custo(data.centro_custo);
      setId_centro_custo(data.id_centro_custo);
      setIdTurma(data.id_turma);
      setId(data.id);
      setTurma(data.turma);
      if (data.data_inicio) {
        setData_inicio(
          data.data_inicio.substring(6, 10) +
            "-" +
            data.data_inicio.substring(3, 5) +
            "-" +
            data.data_inicio.substring(0, 2)
        );
      }
      if (data.data_fim) {
        setData_fim(
          data.data_fim.substring(6, 10) +
            "-" +
            data.data_fim.substring(3, 5) +
            "-" +
            data.data_fim.substring(0, 2)
        );
      }
    }
  }, [data, showModal]);

  async function handleSubmit(e) {
    e.preventDefault();
    const data = {
      id: id,
      id_unidade: idUnidade,
      id_centro_custo: id_centro_custo,
      id_curso: idCurso,
      id_turma: idTurma,
      data_inicio: data_inicio,
      data_fim: data_fim,
    };
    try {
      const response = await api.patch(`/coord/lancamento`, {
        data,
      });
      if (response.data.error) {
        return Swal.fire("Atenção!", response.data.error, "warning");
      }
      Toast.fire({
        icon: "success",
        title: "Editado com sucesso!",
      });
      setShowModal(!showModal);
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (error) {
      alert(
        error
      ); /*Swal('Atenção!', 'Serviço indisponível no momento', 'error')*/
    }
  }
  return (
    <>
      {showModal ? (
        <Background
          ref={modalRef}
          onClick={(e) => {
            if (modalRef.current === e.target) {
              setShowModal(!showModal);
              // clear();
            }
          }}
        >
          <animated.div style={animation}>
            <ModalContent>
              <br />
              <Form onSubmit={handleSubmit}>
                <h3>Atualizar Lançamento da Turma</h3>
                <FormContent>
                  <Label>Unidade:</Label>
                  <Select
                    type="name"
                    value={unidade}
                    placeholder="unidade"
                    onChange={(e) => {
                      setUnidade(e.target.value);
                      setIdUnidade(e.target[e.target.options.selectedIndex].id);
                    }}
                    required
                  >
                    {unidades.map((u, i) => (
                      <option id={u.id}>{u.nome}</option>
                    ))}
                  </Select>
                  <Label>Curso:</Label>
                  <Select
                    value={curso}
                    placeholder="Curso"
                    onChange={(e) => {
                      setCurso(e.target.value);
                      setIdCurso(e.target[e.target.options.selectedIndex].id);
                    }}
                    required
                  >
                    {cursos.map((c, i) => (
                      <option id={c.id}>{c.nome}</option>
                    ))}
                  </Select>
                  <Label>Centro de Custo:</Label>
                  <Select
                    type="centro_custo"
                    value={centro_custo}
                    placeholder="centro_custo"
                    onChange={(e) => {
                      setCentro_custo(e.target.value);
                      setId_centro_custo(
                        e.target[e.target.options.selectedIndex].id
                      );
                    }}
                    required
                  >
                    <option selected disabled value="">
                      {centros_custo?.filter((c) => c.ativo === 1).length > 0
                        ? "Selecione o centro de custo"
                        : "Nenhum centro de custo encontado"}
                    </option>
                    {centros_custo?.map((c, i) => {
                      return (
                        c.ativo === 1 && (
                          <option id={c.id} key={i}>
                            {c.nome}
                          </option>
                        )
                      );
                    })}
                  </Select>
                  <Label>Turmas:</Label>
                  <Select
                    type="centro_custo"
                    value={turma}
                    placeholder="centro_custo"
                    onChange={(e) => {
                      setTurma(e.target.value);
                      setIdTurma(e.target[e.target.options.selectedIndex].id);
                    }}
                    required
                  >
                    {turmas.map((t, i) => (
                      <option id={t.id}>
                        {t.turma
                          .replaceAll("TÉCNICO EM ", "")
                          .replaceAll("CURSO TÉCNICO ", "")}
                      </option>
                    ))}
                  </Select>
                  <Label>Data Início:</Label>
                  <Input
                    type="date"
                    value={data_inicio}
                    onChange={(e) => setData_inicio(e.target.value)}
                    required
                  />
                  <Label>Data Fim:</Label>
                  <Input
                    type="date"
                    value={data_fim}
                    onChange={(e) => setData_fim(e.target.value)}
                    required
                  />
                </FormContent>
                <br />
                <Button type="submit">Atualizar</Button>
              </Form>
              <CloseModalButton
                onClick={() => {
                  setShowModal(!showModal);
                  // clear();
                }}
              />
            </ModalContent>
          </animated.div>
        </Background>
      ) : null}
    </>
  );
}
